import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Navbar from './Navbar';
import TermsConditionsSection from './TermsConditionsSection';
import './TermsConditions.css';

function TermsConditions() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page">
      <Navbar />
      <button className="back-button" onClick={() => navigate('/')} aria-label="Go back to home">
        <FaArrowLeft /> Back
      </button>
      
      <div className="terms-page-content">
        <TermsConditionsSection />
      </div>
    </div>
  );
}

export default TermsConditions;